import Doc from '@/components/.doc/Doc.vue';
import ButtonsDoc from '@/components/.doc/ButtonsDoc.vue';
import FormDoc from '@/components/.doc/FormDoc.vue';
import TypographyDoc from '@/components/.doc/TypographyDoc.vue';
import ColorDoc from '@/components/.doc/ColorDoc.vue';
import ContainerDoc from '@/components/.doc/ContainerDoc.vue';

export default [
    {
        name: 'doc',
        path: '/doc',
        redirect: '/doc/buttons',
        component: Doc,
        meta: { public: true },
        children: [
            {
                name: 'buttons',
                path: 'buttons',
                component: ButtonsDoc,
                meta: { public: true },
            },
            {
                name: 'forms',
                path: 'forms',
                component: FormDoc,
                meta: { public: true },
            },
            {
                name: 'typography',
                path: 'typography',
                component: TypographyDoc,
                meta: { public: true },
            },
            {
                name: 'color',
                path: 'color',
                component: ColorDoc,
                meta: { public: true },
            },
            {
                name: 'container',
                path: 'container',
                component: ContainerDoc,
                meta: { public: true },
            },
        ],
    },
];
